import styled from "@emotion/styled";
import theme from "../../styles/theme";

export const HeroAuthorBase = styled.div`
  padding: 2rem 0;

  ${theme.largerThan.md} {
    padding: 3rem 0;
  }
`;

export const Content = styled.div`
  max-width: ${theme.narrowWidth};
  margin: 0 auto;
  display: grid;
  grid-template-rows: 200px 1fr;
  gap: 2rem;

  ${theme.largerThan.md} {
    grid-template-rows: none;
    grid-template-columns: 300px 1fr;
  }
`;

export const Image = styled.img`
  border-radius: 100%;
  max-width: 200px;
  aspect-ratio: 1/1;

  ${theme.largerThan.md} {
    max-width: 300px;
  }
`;

export const AuthorInfo = styled.div`
  max-width: 700px;

  h1 {
    margin-top: 0;
  }
`;

export const AuthorSocialLinks = styled.ul`
  margin: ${theme.spacing[4]} 0 0;
  padding: ${theme.spacing[4]} 0 0;
  display: flex;
  gap: ${theme.spacing[4]};
  border-top: 1px solid ${theme.colors.darkBlues[10]};
  list-style: none;

  li {
    a {
      font-size: ${theme.fontSizes[3]};
      color: ${theme.colors.darkBlues[75]};

      &:hover {
        color: ${theme.colors.blues[100]};
      }
    }
  }
`;
